import { api } from '../configs/axiosConfigs';

export const getCredits = async () => api.get('/credits');

// Starts a Stripe Checkout payment; the response has the Stripe page to send the browser to.
export const startCreditCheckout = async (packageKey: string, quantity?: number) =>
  api.post('/credits/checkout', { package: packageKey, quantity });
